import { render, staticRenderFns } from "./FormCollection.vue?vue&type=template&id=ecf153dc&"
import script from "./FormCollection.vue?vue&type=script&lang=js&"
export * from "./FormCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports